import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {UserCarePlanVisitTypeItemDgSearchResults} from "../models/datagrid-search-results/user-care-plan-visit-type-item.dg-search-results.model";
import {UserCarePlanVisitTypeService} from "../providers/user-care-plan-visit-type.service";

@Injectable()
export class UserCarePlanVisitTypeDetailsResolve implements Resolve<UserCarePlanVisitTypeItemDgSearchResults> {
  constructor(private userCarePlanVisitTypeService: UserCarePlanVisitTypeService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UserCarePlanVisitTypeItemDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    let queryParam = route.queryParams['uuid'];
    if (queryParam !== undefined) {
      let map = new Map<string, string>();
      map.set("userCarePlanUUID", queryParam);
      return this.userCarePlanVisitTypeService.searchForResults(environment.DEFAULT_RESULTS_LIMIT, 0, map, 'ASC', 'itemStartDate').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    } else {
      return this.userCarePlanVisitTypeService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'itemStartDate').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }
  }
}
